import React from 'react';
import {
  IconAdd, IconLink, IconTrash, IconEdit, IconCopy, IconStatus,
  IconTag, IconArrows, IconPalette, IconNotes, IconPackage, IconInput,
  IconCheck, IconSettings, IconMove, IconGroup, IconDefault,
} from './icons';

/**
 * Format action type for display
 * Converts SNAKE_CASE to Title Case
 */
export const formatActionType = (type) => {
  if (!type) return 'Action';
  return type
    .replace(/_/g, ' ')
    .toLowerCase()
    .replace(/\b\w/g, c => c.toUpperCase());
};

/**
 * Format timestamp for display
 */
export const formatTime = (timestamp) => {
  const date = new Date(timestamp);
  return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' });
};

/**
 * Get icon component for action type
 */
export const getActionIcon = (type) => {
  const icons = {
    'ADD_TASK': <IconAdd />,
    'ADD_CONNECTED_TASK': <IconLink />,
    'DELETE_TASK': <IconTrash />,
    'DELETE_TASKS': <IconTrash />,
    'RENAME_TASK': <IconEdit />,
    'DUPLICATE_TASK': <IconCopy />,
    'CHANGE_STATUS': <IconStatus />,
    'CHANGE_CATEGORY': <IconTag />,
    'CHANGE_DEPENDENCIES': <IconArrows />,
    'CHANGE_ICON': <IconPalette />,
    'CHANGE_NOTES': <IconNotes />,
    'CHANGE_INTERNAL_NOTES': <IconNotes />,
    'CHANGE_DELIVERABLES': <IconPackage />,
    'CHANGE_INPUTS': <IconInput />,
    'CHANGE_DECISION_ANSWER': <IconCheck />,
    'CHANGE_DECISION_OPTIONS': <IconSettings />,
    'MOVE_NODE': <IconMove />,
    'MOVE_NODES': <IconGroup />,
  };
  return icons[type] || <IconDefault />;
};

/**
 * Parse description into title and detail
 * Format: "Title: detail" or just "Title"
 */
export const parseDescription = (action, formatActionType) => {
  const desc = action.description || formatActionType(action.type);
  // Look for patterns like "Task Name: X → Y" or "Rename: "old" → "new""
  const colonIndex = desc.indexOf(':');
  if (colonIndex > 0 && colonIndex < desc.length - 1) {
    return {
      title: desc.slice(0, colonIndex).trim(),
      detail: desc.slice(colonIndex + 1).trim(),
    };
  }
  return { title: desc, detail: null };
};
